import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Autosuggest from 'react-autosuggest';
import { loadSearchSuggestions } from '../../actions';
import listensToClickOutside from 'react-onclickoutside';


function  mapStateToProps(state) {
  return {
    searchSuggestions: state.searchSuggestions,
  }
}


@connect(mapStateToProps, { push, loadSearchSuggestions })
export class SearchForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      query: '',
      propQueryAllowed: true
    }
  }

  close = event => {
    if (this.props.close) {
      this.props.close()
    }
  }

  updateQuery = query => {
    this.setState({ query, propQueryAllowed: false });
  }

  doSearch = event => {
    event.preventDefault();
    if (this.state.query) {
      this.props.push(`/search?q=${this.state.query}`);
    }
    this.close(event)
  }

  renderSuggestion = (suggestion) => {
    return <span>{suggestion.name}</span>;
  }

  shouldRenderSuggestions = (value) => {
    if (value) {
      return value.trim().length > 2;
    }
    return false;
  };


  onSuggestionsFetchRequested = ({ value }) => {
    this.props.loadSearchSuggestions(value);
  }

  onSuggestionsClearRequested = () => {
  };

  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  onInputChange = (e, { newValue, method }) => {
    if (method === 'type') {
      this.updateQuery(newValue)
    }
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
    event.preventDefault();
    if(suggestion.id == 0 ) {
      this.doSearch(event);
    } else {
      this.props.push(`/organizations/${suggestion.id}`);
      this.close(event)
    }
  }

  render() {
    let { query } = this.props
    let q = (query) ? query : ''
    let value = (this.state.propQueryAllowed) ? this.state.query || q : this.state.query
    let inputProps = {
      name: 'q',
      value,
      onChange: this.onInputChange,
      placeholder: 'Search...',
      autoComplete: 'off',
      tabIndex: 1,
      autoFocus: !Boolean(q)
    };

    const suggestions = this.props.searchSuggestions.results;
    let finalSuggestions = suggestions.slice(0);
    if(finalSuggestions.length > 0) {
      finalSuggestions.push({
        name: <strong>show all listings</strong>,
        id: 0
      });
    }

    return (
      <form onSubmit={this.doSearch} className="headerSearchFormContainer">
        <Autosuggest suggestions={finalSuggestions}
                    inputProps={inputProps}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    focusInputOnSuggestionClick={false}
                    renderSuggestion={this.renderSuggestion}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    onSuggestionSelected={this.onSuggestionSelected} />
      <button className="button search-button" onClick={this.doSearch} type="submit"><i className="fa fa-search"></i></button>
      </form>

    )
  }

}


@listensToClickOutside
class SearchWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  open = (event) => {
    event.preventDefault();
    this.setState({ isOpen: true })
  }

  close = (event) => {
    event.preventDefault();
    this.setState({ isOpen: false })
  }

  toggle = (event) => {
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen})
  }

  handleClickOutside = (event) => {
    this.setState({ isOpen: false })
  };

  render() {
    let popup = <SearchForm close={this.close}/>
    return (
      <div className="headerSearchWidget">
        <div onClick={this.open} className="button"><i className="fa fa-search"></i></div>
        {this.state.isOpen ? popup : ''}
      </div>
    )
  }
}

export default SearchWidget



// WEBPACK FOOTER //
// ./src/components/header/Search.jsx